import graphql__7e9ee7fa4dd66ca88f70 from "./__generated__/ContactList_query.graphql.ts";import * as React from "react"
import {useEffect, useTransition} from "react"
import {graphql} from "react-relay";
import LoadMoreButton from "./presentational/LoadMoreButton";
import ContactListItem from "./ContactListItem";
import {usePaginationFragment} from "react-relay/hooks";
import {useIntl} from "react-intl";

type ContactListProps = {
    queryRef: any
    searchTerm?: string
    onLoadingChange?: (isLoading: boolean) => void
}

const ContactList: React.FC<ContactListProps> = (props) => {
    const intl = useIntl();
    const [isPending, startTransition] = useTransition();
    const {data, hasNext, loadNext, isLoadingNext, refetch} = usePaginationFragment(
        graphql__7e9ee7fa4dd66ca88f70,
        props.queryRef
    );

    useEffect(() => {
        // Use startTransition to keep the old data visible while loading new data
        // This prevents the Suspense fallback from showing
        startTransition(() => {
            refetch({searchTerm: props.searchTerm}, {fetchPolicy: 'store-and-network'});
        });
    }, [props.searchTerm, refetch])

    useEffect(() => {
        // Notify parent component about loading state
        props.onLoadingChange?.(isPending);
    }, [isPending, props]);

    if (!data.contacts || data.contacts.totalCount === 0) {
        return (<></>);
    }

    return (
        <nav className="flex-1 min-h-0 relative overflow-y-auto" aria-label={intl.formatMessage({id: 'navigation.contacts'})}>
            <ul className="relative z-0 divide-y divide-gray-200">
                {data.contacts.edges
                    .filter((edge) => edge.node != null)
                    .map(
                        (edge, index) => {
                            return <ContactListItem key={index} contact={edge.node}/>
                        }
                    )
                }
            </ul>
            {hasNext && <LoadMoreButton onClick={() => loadNext(100)} isLoadingNext={isLoadingNext}/>}
        </nav>
    )
}

export default ContactList;
